import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { cn } from "../../utils";
export const TrackStats = props => {
    const { name, liquidated, discovered, maxDiscovered, className, padding } = props;
    const ok = liquidated === discovered && discovered === maxDiscovered;
    const zero = ok && discovered === 0;
    const nSymb = maxDiscovered.toString().length;
    return (_jsxs("div", { className: clsx("flex flex-row", ok
            ? zero
                ? "text-gray-50 border-gray-50 opacity-70"
                : "text-green-500 border-green-500"
            : "text-red-600 border-red-600", className), children: [!!name && _jsx("pre", { children: `${name}: ` }), _jsxs("div", { className: "flex flex-row", children: [_jsx("pre", { children: padding ? liquidated?.toString().padStart(nSymb, " ") : liquidated }), _jsx("pre", { children: "/" }), _jsx("pre", { children: padding ? discovered?.toString().padEnd(nSymb, " ") : discovered })] })] }));
};
export const SimpleTrackStats = props => {
    const { liquidated = 0, discovered = 0, warning = 0, className } = props;
    const notLiquidated = discovered - liquidated;
    const errored = notLiquidated - warning;
    return (_jsxs("div", { className: cn("inline-flex", className), children: [_jsx("pre", { className: "text-green-500", children: liquidated }), _jsx("pre", { children: "/" }), _jsx("pre", { className: "text-orange-500", children: warning }), _jsx("pre", { children: "/" }), _jsx("pre", { className: "text-red-500", children: errored })] }));
};
